class NewsBlock {
  constructor() {
    this.container = document.querySelector('.news__container');
    if (!this.container) return;

    this.grid = this.container.querySelector('[data-news-grid="1"]');
    this.button = this.container.querySelector('.news__load-more');

    if (!this.grid || !this.button) return;

    this.isLoading = false;
    this.button.addEventListener('click', this.handleLoadMore.bind(this));

    this.updateFeaturedCards();
  }

  updateFeaturedCards() {
    if (!this.grid) return;

    const cards = this.grid.querySelectorAll('.news__card');

    cards.forEach((card) => {
      card.classList.remove('news__card--featured');
    });

    if (!cards.length) return;

    const firstCard = cards[0];
    const lastCard = cards[cards.length - 1];

    firstCard.classList.add('news__card--featured');

    if (lastCard && lastCard !== firstCard) {
      lastCard.classList.add('news__card--featured');
    }
  }

  handleLoadMore() {
    if (this.isLoading) return;
    if (!window.backendData) return;

    const ajaxUrl = window.backendData.ajaxUrl;
    const nonce = window.backendData.newsNonce;

    const offset = parseInt(this.button.dataset.offset || '0', 10);
    const postsPerPage = parseInt(this.button.dataset.postsPerPage || '6', 10);

    if (!ajaxUrl || !nonce) return;

    const formData = new FormData();
    formData.append('action', 'news');
    formData.append('offset', String(offset));
    formData.append('posts_per_page', String(postsPerPage));
    formData.append('nonce', nonce);

    this.isLoading = true;
    this.button.disabled = true;

    fetch(ajaxUrl, {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        if (!data || !data.success || !data.data || !data.data.html) {
          return;
        }

        this.grid.insertAdjacentHTML('beforeend', data.data.html);
        this.updateFeaturedCards();

        const newOffset = typeof data.data.newOffset === 'number'
          ? data.data.newOffset
          : offset + postsPerPage;

        this.button.dataset.offset = String(newOffset);

        if (!data.data.hasMore) {
          this.button.remove();
        } else {
          this.button.disabled = false;
        }
      })
      .catch(() => {
        this.button.disabled = false;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}

new NewsBlock();

